module.exports = __webpack_public_path__ + "../static/media/5630-font.3635a93e.ttf";